import React from 'react'
import { ListIcon as ChakraListIcon } from '@chakra-ui/react'

export const ListIcon: React.FC<
  React.PropsWithChildren<
    Pick<React.ComponentProps<typeof ChakraListIcon>, 'as' | 'sx' | 'children'>
  >
> = props => <ChakraListIcon {...props} />
